// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_p2","popupBlock":"e_q2"};